import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import TrafficRoadSafetyDetails from '../../subdepartmentdetails/TrafficRoadSafety'


function TrafficRoadSafety() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Traffic and Road Safety Enforcement || Public Safety";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Public Safety"
            title="Traffic Road Safety"
            subtitledown="Department of Public Safety"
           />
            <TrafficRoadSafetyDetails/>
        </div>
    </>
  )
}

export default TrafficRoadSafety